// Copyright (c) 2017 Deere & Company

import * as actions from '../../actions-list';
import {getDefaultState} from '../state';

const resetDebitType = () => getDefaultState().debitType;

const updateDebitType = (state, action) => action.debitType;

export default (state = getDefaultState().debitType, action) => {

    const actionTypes = {
        [actions.RESET_TCSM_CLAIM_DEBIT]: resetDebitType,
        [actions.UPDATE_TCSM_CLAIM_DEBIT_TYPE]: updateDebitType
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/reducers/debit-type.js